import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import Panel from '../components/Panel';

class Gps extends React.Component {
  constructor() {
    super();

    this.state = {
      size: 300
    }
  }

  render() {
    const { size } =  this.state;
    const { gps } = this.props.wheelhouse;

    const panelStyle = {
      width: size,
      height: size,
      padding: 20
    }

    return (
      <Panel>
        <div className="p-3 h-100">
          <div className="bg-gray d-flex flex-column h-100 rounded">
            <div className="p-1 d-flex justify-content-between border-bottom border-secondary">
              <small>{gps.title}</small>
              <small>{gps.datetime}</small>
            </div>

            <div className="flex-grow-1 d-flex flex-column justify-content-center">
              <div className="text-center"><h2>{gps.lng}</h2></div>
              <div className="text-center"><h2>{gps.lat}</h2></div>
            </div>

            <Row className="border-top border-secondary p-0 m-0 text-center flex-grow-0">
              <Col>
                <small>SOG</small>
                <h3>{gps.sog}</h3>
              </Col>

              <Col>
                <small>COG</small>
                <h3>{gps.cog}</h3>
              </Col>
            </Row>
          </div>
        </div>

      </Panel>
    );
  }
}

const mapStoreToProps = (store) => ({
  wheelhouse: store.wheelhouse,
});

export default connect(mapStoreToProps)(Gps);
